import { NgModule } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';
import { CreateNewTemplateService } from './create-new-template.service';
import { CreateNewTemplateComponent } from './create-new-template.component';
import { MatInputModule } from '@angular/material/input';
import { DomainMessagesService } from '../domain/domain-messages.service';
import { RouterModule, Routes } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { LexiconModule } from '@galaxy/lexicon';
import baseTranslation from '../../../assets/i18n/en_devel.json';
import { WEBLATE_COMPONENT_NAME } from '../../constants';

const routes: Routes = [
  {
    path: '',
    component: CreateNewTemplateComponent,
  },
];

@NgModule({
  imports: [
    CommonModule,
    MatCardModule,
    RouterModule.forChild(routes),
    TranslateModule,
    LexiconModule.forChild({
      componentName: WEBLATE_COMPONENT_NAME,
      baseTranslation: baseTranslation,
    }),
    FormsModule,
    MatInputModule,
    MatButtonModule,
  ],
  declarations: [CreateNewTemplateComponent],
  exports: [RouterModule],
  providers: [CreateNewTemplateService, DomainMessagesService],
})
export class CreateNewTemplateModule {}
